import { Module } from '../../../ts/Module';
import { CheckboxGroupCtrl } from './CheckboxGroupCtrl';

interface ICheckboxScope extends ng.IScope {
  checked: () => boolean;
  disabled: () => boolean;
  toggle: () => void;
}

/* Custom checkbox control. Two ways to use:
*
*  1. Two-way binding to a scope property, like in a form. Includes all the fancy Angular form
*     features: http://docs.angularjs.org/guide/forms
*
*       tb:checkbox(ng-model="model.bool")
*
*     For a checkbox with a clickable label
*
*       tb:checkbox-group
*         tb:checkbox
*         tb:checkbox-label Content
*
*  2. Reflect value of expressions. You'll have to define an ng-click if you want behavior on click.
*
*       tb:checkbox(checked="amIAwesome()")
*
*/
Module.instance().directive('tbCheckbox', <any[]>[
  () => {
    return {
      restrict: 'E',
      replace: true,
      require: ['?ngModel', '^?tbCheckboxGroup'],
      templateUrl: 'checkbox.html',
      scope: {
        checked: '&'
      },
      link: (scope: ICheckboxScope, elm: JQuery, attrs: ng.IAttributes, ctrls: any[]) => {
        const ngModelCtrl = <ng.INgModelController> ctrls[0];
        const checkboxGroupCtrl = <CheckboxGroupCtrl> ctrls[1];

        if(!ngModelCtrl) {
          return;
        }
        const disabled = () => elm.hasClass('tb-disabled');

        scope.checked = () => ngModelCtrl.$viewValue;

        scope.toggle = () => {
          if (disabled()) return;
          ngModelCtrl.$setViewValue(!ngModelCtrl.$viewValue);
          ngModelCtrl.$render();
        };

        if (checkboxGroupCtrl) {
          checkboxGroupCtrl.toggle = scope.toggle;
          checkboxGroupCtrl.disabled = disabled;
        }
      }
    };
  }
]);
